import { useEffect, useState } from 'react';
import { Tooltip } from 'react-bootstrap';
import RadioButtonOptionTemplate from './RadioButtonOptionTemplate';
import icBtn from '../../assets/svg/btn/btn-ask.svg';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axiosClient from '../../../axios-client.js';
import AskForTemplate from '../../views/broadcasts/AskForTemplate';

const RadioContainerTemplate = ({ idTemplate, onClickTemplate, slidToshow, templateName, getVariablesNames, isBroadcast }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);
    // const [selectedTemplateName, setSelectedTemplateName] = useState(null);
    const [filteredTemplates, setFilteredTemplates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [templates, setTemplates] = useState([]);
    const [ searchTerm, setSearchTerm ] = useState('');
    const [clienNeme, setClienNeme] = useState(''); 

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const settings = {
        dots: false,
        infinite: false,
        speed: 100,
        slidesToShow: slidToshow,
        slidesToScroll: 1,
        arrows: true,
        centerMode: false,
        centerPadding: '10px',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    infinite: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
        ]
    };

    useEffect(() => {
        userInfo();
        if (idTemplate) {
            getTemplates();
            // if (templates.length >= 9) {
            setSearchTerm('');
            // }
        }
    }, [idTemplate]);

    useEffect(() => {        
        const updatedFilteredTemplates = searchTerm
            ? templates.filter(template => template.name.toLowerCase().includes(searchTerm.toLowerCase()))
            : templates;
        setFilteredTemplates(updatedFilteredTemplates);
        
    }, [searchTerm, templates]);    

    const getTemplates = () => {
        setLoading(true);
        axiosClient.get(`/templates?language_id=${idTemplate}&is_broadcast=${isBroadcast}`)
            .then(({ data }) => {
                setLoading(false);
                setTemplates(data.data);
                setFilteredTemplates(data.data);
            })
            .catch(() => {
                setLoading(false);
                // Handle error
            });
    };

    const handleFilterChange = (filterValue) => {
        switch (filterValue) {
            case 'forms':
                setFilteredTemplates(templates.filter(template => template.has_flow_form === true));
                break;
            case 'no-forms':
                setFilteredTemplates(templates.filter(template => template.has_flow_form === false));
                break;
            case 'all':
            default:
                setFilteredTemplates(templates);
                break;
        }
    };

    const handleSelect = (optionId, optionTitle, dataVariablesName, hasFlow, hasForm, formFlow) => {
        // setSelectedTemplateName(optionTitle);
        templateName(optionTitle);
        onClickTemplate(optionId, hasFlow, hasForm, formFlow);
        setSelectedOption(optionId);
        getVariablesNames(dataVariablesName);
    };

    const NextArrow = (props) => {
        const { className, onClick } = props;
        return (
            <div
                className={`${className} custom-arrow`}
                onClick={onClick}
                style={{ height: '78px !important', width: '78px !important', position: 'absolute', top: '40%', transform: 'translateY(-50%)', zIndex: 1 }}
            >
            </div>
        );
    };

    const PrevArrow = (props) => {
        const { className, onClick } = props;
        return (
            <div
                className={`${className} custom-arrow`}
                onClick={onClick}
                style={{ height: '78px !important', width: '78px !important', position: 'absolute', left: '9px', top: '40%', transform: 'translateY(-50%)', zIndex: 1 }}
            >
            </div>
        );
    };


    const userInfo = async () => {
        setLoading(true);
        try {
            const { data } = await axiosClient.get('/user');
            // Assuming the name is in the format "First Last"
            const firstName = data.data.name.split(' ')[0];
            setClienNeme(firstName);
        } catch (error) {
            console.error('Error fetching user information:', error);
        } finally {
            setLoading(false);
        }
    };
    
      
    return (
        <div className={`${isBroadcast ? "" : "px-3 container"} pb-4`}>
            <div className='row my-4 justify-content-end align-items-center'>
            {templates.length > 10 && (
                    <div className={`${!isBroadcast ? "col-md-3 px-1 me-auto" : "col-md-3"} mb-1`}>
                        <input
                            type="text"
                            className="form-control rounded-pill"
                            placeholder="Search templates..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                )}
                <div className={`${!isBroadcast ? "col-md-2 px-1 my-auto" : "col-md-3"} mb-1`}>
                    <div className='form-control rounded-pill d-flex'>
                        <p className='p-0 my-2'>Select:</p>
                        <select className="border-0 p-1" aria-label="Select type template" onChange={(e) => handleFilterChange(e.target.value)}>
                            <option value="all">All</option>
                            <option value="forms">With Forms</option>
                            <option value="no-forms">Without Forms</option>
                        </select>
                    </div>
                </div>
            </div>

            <AskForTemplate show={showModal} handleClose={handleCloseModal} />
            <Slider className='radio-container' {...settings} nextArrow={<NextArrow />} prevArrow={<PrevArrow />}>
                {loading ? (
                    <span>Loading...</span>
                ) : (
                    filteredTemplates.map((item) => {
                        const catchDataNames = item.catch_data?.map((catchData) => catchData.name) || [];
                        const variablesNames = item.global_variables.map((variable) => variable.name);
                        const classCatch = catchDataNames.length === 0 ? 'd-none' : '';
                        const classVariables = variablesNames.length === 0 ? 'd-none' : '';

                        return (
                            <div key={item.id} className='flex justify-center'>
                                <RadioButtonOptionTemplate
                                    className='radio-container'
                                    id={item.id}
                                    name={item.name}
                                    imageSrc={item.image}
                                    title={item.name}
                                    subTitle={item.name}
                                    toolTip={<Tooltip id='tooltip'>This is the data we will collect for you for each recipient interacting with the message and replying to all questions asked.</Tooltip>}
                                    variablesToolTip={<Tooltip id='tooltip'>These are the custom variables data that will appear inside the messages you send and make each message sent unique for each recipient.</Tooltip>}
                                    globalClass={classVariables && classCatch ? 'd-none' : ''}
                                    classVairiables={classVariables}
                                    classCatch={classCatch}
                                    variables={item.variables.map(variable => variable.name)}
                                    globalvariables={item.global_variables.map(global_variables => global_variables.name)}
                                    catch_data={item.catch_data.map(catch_data => catch_data.name)}
                                    filedata={item.file_data ? item.file_data.name : ''}
                                    selected={selectedOption === item.id}
                                    onSelect={() => handleSelect(item.id, item.name, item.variables.map(variable => variable.name), item.has_flow, item.has_flow_form, item.has_flow)}
                                />
                            </div>
                        );
                    })
                )}

                <div role='button' onClick={handleShowModal} className='justify-content-center align-items-start'>
                    <div className='d-flex justify-content-center align-items-start'>
                        <div className='card-contact card-template border-0 mx-3 d-flex justify-content-center align-items-center'>
                            <div className={'card border-0 d-flex justify-content-center align-items-center'}>
                                <div className='card-image border-0'>
                                    <img width={74} height={74} src={icBtn} alt="Ask for template" />
                                </div>
                                <span className='border-0 bg-transparent px-4 py-4 mt-1 mb-3 text-center card-btm-title'>Ask for a new Template</span>
                            </div>
                        </div>
                    </div>
                </div>

            </Slider>
        </div>
    );
};

export default RadioContainerTemplate;
